module.exports = __webpack_public_path__ + "static/media/compact-Creative-demo.905fb62b.png";